export default __webpack_public_path__ + "static/media/signup.1d508c39.gif";